import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signLaboratoryPrescriptionDocumentInput,
  useChSignLaboratoryPrescriptionMutation as useChSignLaboratoryPrescriptionMutationType,
} from "@/modules/patients/detail/laboratory-prescription/ch/services/__generated__/useChSignLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignLaboratoryPrescriptionMutation($input: Ch_signLaboratoryPrescriptionDocumentInput!) {
    ch_signLaboratoryPrescriptionDocument(input: $input) {
      ch_LaboratoryPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chLaboratoryPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignLaboratoryPrescriptionMutationType>, "variables"> & {
  id: Ch_signLaboratoryPrescriptionDocumentInput["id"]
}

const useChSignLaboratoryPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignLaboratoryPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignLaboratoryPrescriptionMutation }
